import React, { useState } from 'react';
import { updatePassword } from '../apiCallsHelper/userapicalls';
import { isAuthenticated } from '../apiCallsHelper/authapicalls';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';



const ChangePassword = ({ currentPassword, setCurrentPassword, newPassword, setNewPassword }) => {

    const { user, token } = isAuthenticated();

    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);



    const toggleCurrentPasswordType = (event) => {
        event.preventDefault();
        setShowCurrentPassword(!showCurrentPassword);
    }

    const toggleNewPasswordType = (event) => {
        event.preventDefault();
        setShowNewPassword(!showNewPassword);
    }

    const handleUpdatePassword = () => {
        updatePassword(user._id, token, currentPassword, newPassword).then(data => {
            if (data.error) {
                toast.error(data.error);
                // console.log("data error in chng password: ", data.error)
            }
            else {
                toast.success(data.message);
                // console.log("data in chng password: ", data);
            }
        })
    }


    const handleCancel = () => {
        setCurrentPassword("");
        setNewPassword("");
    }



    return (
        <>
            <div className='w-[150px]    xs:w-[200px]    sm:w-[250px]    md:w-[520px]    smLaptop:w-[620px]   lg:w-[620px]   xl:w-[620px]  mx-auto'>
                <div className='w-[150px] text-base   xs:w-[200px] xs:text-base    sm:w-[250px] sm:text-lg    md:w-[520px] md:text-xl   smLaptop:w-[620px] smLaptop:text-xl  lg:w-[620px] lg:text-xl   xl:w-[620px] xl:text-xl    mt-16 mb-4  text-blue-900 text-center font-bold'>
                    Change/Update password
                </div>
                <div className="    w-[150px]    xs:w-[200px]    sm:w-[250px]     md:w-[400px]   smLaptop:w-[400px]      lg:w-[400px]     xl:w-[400px] mx-auto mt-10">
                    <div className="flex flex-wrap -mx-3 mb-2 ">
                        <div className="w-full px-3 mb-4 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                htmlFor="grid-first-name">
                                Password
                            </label>
                            <div className='flex w-full'>
                                <input
                                    name="currentPassword"
                                    value={currentPassword}
                                    onChange={(event) => setCurrentPassword(event.target.value)}
                                    className="py-2 px-2 mb-2      
                                xs:py-2 xs:px-2 xs:mb-1   
                                sm:py-2 sm:px-2 sm:mb-2   
                                md:py-3 md:px-4 md:mb-3     
                                smLaptop:py-3 smLaptop:px-4 smLaptop:mb-3      
                                lg:py-3 lg:px-4 lg:mb-3    
                                xl:py-3 xl:px-4 xl:mb-3     
                                appearance-none block w-full bg-gray-200 text-gray-700 
                                border border-gray-200 rounded leading-tight 
                                focus:outline-blue-500 focus:bg-white"
                                    id="grid-current-password"
                                    type={showCurrentPassword ? "text" : "password"}
                                    placeholder="Current password"
                                />
                                <button type="button" onClick={toggleCurrentPasswordType}>
                                    {showCurrentPassword ?
                                        (
                                            <FontAwesomeIcon icon={faEye} className='ml-[-30px] md:mb-2' size='sm' color='#7292f7' />
                                        ) : (
                                            <FontAwesomeIcon icon={faEyeSlash} className='ml-[-30px] md:mb-2' size='sm' color='#7292f7' />
                                        )}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full px-3">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                htmlFor="grid-last-name">
                                New Password
                            </label>
                            <div className='flex w-full'>
                                <input
                                    name="newPassword"
                                    value={newPassword}
                                    onChange={(event) => setNewPassword(event.target.value)}
                                    className="py-2 px-2 mb-2      xs:py-2 xs:px-2 xs:mb-1   sm:py-2 sm:px-2 sm:mb-2   md:py-3 md:px-4 md:mb-3     smLaptop:py-3 smLaptop:px-4 smLaptop:mb-3      lg:py-3 lg:px-4 lg:mb-3    xl:py-3 xl:px-4 xl:mb-3      appearance-none block w-full bg-gray-200 text-gray-700 
                                border border-gray-200 rounded  leading-tight 
                                focus:outline-blue-500 focus:bg-white focus:border-gray-500"
                                    id="grid-new-password"
                                    type={showNewPassword ? "text" : "password"}
                                    placeholder="New password"
                                />
                                <button type="button" onClick={toggleNewPasswordType}>
                                    {showNewPassword ?
                                        (
                                            <FontAwesomeIcon icon={faEye} className='ml-[-30px] md:mb-2' size='sm' color='#7292f7' />
                                        ) : (
                                            <FontAwesomeIcon icon={faEyeSlash} className='ml-[-30px] md:mb-2' size='sm' color='#7292f7' />
                                        )}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-wrap -mx-3 mb-2">
                        <div className="w-full px-3 mt-2">
                            <div className="flex justify-center">
                                <button onClick={handleCancel}
                                    className="bg-transparent hover:bg-red-500 text-red-500 font-semibold 
                                    hover:text-white py-2 px-6 border border-red-500 hover:border-transparent 
                                    rounded mr-2">
                                    Cancel
                                </button>
                                <button onClick={handleUpdatePassword} className="bg-blue-500 hover:bg-blue-700 text-white 
                                    font-bold py-2 px-6 border border-blue-700 rounded ml-2">
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}


export default ChangePassword